module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transition-item bounceInLeft animated",
    staticStyle: {
      "animation-duration": ".8s"
    },
    style: ({
      'top': _vm.offsetTop
    }),
    attrs: {
      "id": "repo-list-page",
      "transition": "zoom"
    }
  }, [_c('div', {
    ref: "searchwrapper",
    attrs: {
      "id": "search-wrapper"
    }
  }, [_c('search-input', {
    staticClass: "animated",
    attrs: {
      "placeholder": "Find a repository...",
      "buttonText": "SEARCH",
      "transition": "lineup"
    },
    on: {
      "search": _vm.search
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "scrollwrapper",
    attrs: {
      "id": "scroll-wrapper"
    },
    on: {
      "scroll": _vm.scroll
    }
  }, [_c('div', {
    attrs: {
      "id": "repo-list"
    }
  }, [(!_vm.repos.length && _vm.isSearching) ? _c('div', {
    staticClass: "empty-data"
  }, [_vm._v("\n                :-( Sad... No result found!\n            ")]) : [_c('list-transition', _vm._l((_vm.repos), function(repo, index) {
    return _c('repo-item', {
      key: repo.full_name,
      attrs: {
        "repo": repo,
        "data-index": index
      }
    })
  }), 1)]], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f44bdb2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RepoList.vue
// module id = 459
// module chunks = 2